/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetMenu_widget = {|
  +id: string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetMenu_widget",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "EditWidgetDialog_widget",
      "args": null
    }
  ],
  "type": "Widget"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/__generated__/WidgetMenu_widget.graphql.js